import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { Layout } from '@singularsystems/neo-canvas-grid';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { AppService, Types } from '../../../App/Services/AppService';
import { ClientReportCategories } from '../ClientReportCategories';
import DividendWithholdingTaxReportCriteria from './DividendWithholdingTaxReportCriteria';

@NeoReport("DividendWithholdingTax", { category: ClientReportCategories.RegulatoryReports })
export default class DividendWithholdingTaxReport extends Report<DividendWithholdingTaxReportCriteria> {

    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(DividendWithholdingTaxReportCriteria);
    }

    public renderCriteria() {
        return <>
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                            .sort((x, y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))} />
                </Neo.FormGroup>
                <Neo.FormGroup
                    appendText="fa-calendar"
                    bind={this.criteria.meta.startDate}
                    label={TextConstants.Labels.StartDate}
                />
                <Neo.FormGroup
                    appendText="fa-calendar"
                    bind={this.criteria.meta.endDate}
                    label={TextConstants.Labels.EndDate}
                />
            </Neo.GridLayout>
        </>
    }

    public getDefaultGridLayout() {
        return {
            "root": {
                "columns": [
                    {
                        "key": "fundAllocation",
                        "title": "Fund_Allocation"
                    },
                    {
                        "key": "instrumentCode",
                        "title": "Instrument_Code"
                    },
                    {
                        "key": "uniqueTransactionId",
                        "title": "Unique_Transaction_ID"
                    },
                    {
                        "key": "linkedTransactionId",
                        "title": "Linked_Transaction_ID"
                    },
                    {
                        "key": "reversalIndicator",
                        "title": "Reversal_indicator"
                    },
                    {
                        "key": "dividendType",
                        "title": "Dividend_type"
                    },
                    {
                        "key": "dividendSubtype",
                        "title": "Dividend_subtype"
                    },
                    {
                        "key": "numberOfShares",
                        "title": "Number_of_shares"
                    },
                    {
                        "key": "dividendPerShare",
                        "title": "Dividend_per_share"
                    },
                    {
                        "key": "dividendGrossTC",
                        "title": "Dividend_Gross_TC"
                    },
                    {
                        "key": "dividendGrossFC",
                        "title": "Dividend_Gross_FC"
                    },
                    {
                        "key": "taxWithheldTC",
                        "title": "Tax_Withheld_TC"
                    },
                    {
                        "key": "taxWithheldFC",
                        "title": "Tax_Withheld_FC"
                    },
                    {
                        "key": "exchangeRateTCtoFC",
                        "title": "ExchangeRate_TCtoFC"
                    },
                    {
                        "key": "dateDeclared",
                        "title": "Date_declared"
                    },
                    {
                        "key": "datePayable",
                        "title": "Date_payable"
                    },
                    {
                        "key": "currencyIdDividendTransaction",
                        "title": "CurrencyID_Dividend_Transaction"
                    },
                    {
                        "key": "currencyIdFunctional",
                        "title": "CurrencyID_Functional"
                    }
                ]
            }
        } as Layout.IGridLayout;
    }
}